if (document.body.classList.contains('home')){
  
  let scrollpos = window.scrollY;
  const header = document.querySelector("#masthead");
  const header_height = header.offsetHeight;
  
  const add_class_on_scroll = () => header.classList.add("fade-in")
  const remove_class_on_scroll = () => header.classList.remove("fade-in")
  
  var scrollposition = function () {
    scrollpos = window.scrollY;
  
    if (scrollpos >= header_height) { add_class_on_scroll() }
    else { remove_class_on_scroll() }

  };
  
  window.addEventListener('scroll', scrollposition, false);
  window.addEventListener('load', scrollposition, false);
  
}


